import { useQuery } from '@tanstack/react-query';

import axios, { parseAxiosError } from '@/portainer/services/axios/axios';
import { withError } from '@/react-tools/react-query';

import { BackupAzureModel } from '../types';

import { buildUrl } from './backupSettings.service';
import { queryKeys } from './queryKeys';

export function useBackupAzureSettings<T = BackupAzureModel>({
  select,
  enabled,
}: {
  select?: (settings: BackupAzureModel) => T;
  enabled?: boolean;
} = {}) {
  return useQuery(queryKeys.backupAzureSettings(), getBackupAzureSettings, {
    select,
    enabled,
    ...withError('Unable to retrieve Azure Blob backup settings'),
  });
}

async function getBackupAzureSettings() {
  try {
    const { data } = await axios.get<BackupAzureModel>(
      buildUrl('azure', 'settings')
    );

    return data;
  } catch (e) {
    throw parseAxiosError(
      e as Error,
      'Unable to retrieve Azure Blob backup settings'
    );
  }
}
